import { ChangeDetectorRef } from '@angular/core';

/*
 */
export function detectChangesIdle(ref: ChangeDetectorRef) {
  if (!ref || typeof ref.detectChanges !== 'function') return;

  const idle = (window as any).requestIdleCallback || ((fn: () => void) => setTimeout(fn, 0));
  idle(() => {
    try {
      ref.detectChanges();
    } catch (e) {
      console.warn('[detectChangesIdle] failed:', e);
    }
  });
}

/*
 */
export async function idleMapSequential<T>(items: T[], fn: (item: T, index: number) => Promise<void>): Promise<void> {
  for (let i = 0; i < items.length; i++) {
    await new Promise<void>((resolve) => {
      requestIdleCallback(() => {
        void (async () => {
          try {
            await fn(items[i], i);
          } catch (e) {
            console.error('idleMapSequential error', e);
          }
          resolve();
        })();
      });
    });
  }
}
